var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27.7 19.3",
    style: {
      enableBackground: "new 0 0 27.7 19.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00807B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Resend",
    transform: "translate(-270.34 -447.057)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M297.9,459.2c-0.1-0.2-0.3-0.3-0.5-0.3c0,0,0,0,0,0l-2.3,0c-0.3-0.9-0.8-1.7-1.5-2.3c-1.1-1-2.5-1.6-4.1-1.5 c-1.5,0.1-2.9,0.7-3.9,1.8s-1.6,2.5-1.5,4.1c0.1,1.5,0.7,2.9,1.8,3.9c1.1,1,2.4,1.5,3.8,1.5c0.1,0,0.1,0,0.2,0c0.7,0,1.4-0.2,2-0.5 c0.4-0.2,0.5-0.6,0.4-1s-0.6-0.6-1-0.4c-0.5,0.2-1,0.3-1.5,0.3c-1.1,0-2.2-0.4-3-1.1c-0.8-0.8-1.3-1.8-1.3-2.9c0-1.1,0.4-2.2,1.1-3 c0.8-0.8,1.8-1.3,2.9-1.3c1.1,0,2.2,0.4,3,1.1c0.4,0.4,0.7,0.8,0.9,1.2l-2.2,0c-0.2,0-0.4,0.1-0.5,0.3c-0.1,0.2-0.1,0.4,0.1,0.5 l3.1,3.7c0.1,0.1,0.2,0.2,0.4,0.2c0,0,0,0,0,0c0.1,0,0.3-0.1,0.4-0.2l3-3.8C298,459.6,298,459.4,297.9,459.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    className: "st0",
    d: "M283,460.1h-10.8v-7.2c0.9,0.7,2.1,1.7,4.1,3.2c0.8,0.7,2.3,2.1,4,2.1c1.7,0,3.1-1.4,4-2.1 c1.9-1.5,3.2-2.5,4.1-3.2v1.3c0.1,0,0.2,0,0.4,0c0.5,0,1,0.1,1.5,0.2v-5.5c0-1-0.8-1.9-1.9-1.9h-16.1c-1,0-1.9,0.8-1.9,1.9 c0,0,0,0,0,0v11.1c0,1,0.8,1.9,1.9,1.9h11.2C283.1,461.3,283,460.7,283,460.1z M272.2,448.9h16.1v1.6c-0.9,0.7-2.2,1.8-5.2,4.1 c-0.7,0.5-1.9,1.7-2.8,1.7c-0.9,0-2.2-1.2-2.8-1.7c-3-2.3-4.3-3.4-5.2-4.1L272.2,448.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResend);
export default __webpack_public_path__ + "static/media/resend.16ff07ee0ff3cb1b29d79abede67e442.svg";
export { ForwardRef as ReactComponent };